import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
export default function RepBrand({rows,Month1,Month2,Month3}) {

const columns = [
  { field: "id", headerName: "ID", width: 40, hide: true },
  {
    field: 'brand',
    headerName: 'Brand',
    width: 100,
    sortable: false,
  },
  {
    field: 'sum_m1_adjusted_budget_unit',
    headerName:`Bud U(${Month1})`,
    width: 170,
    hide:true,
    sortable: true,
  },
  {
    field: 'sum_m1_adjusted_budget_value',
    headerName: `Bud V(${Month1})`,
    width: 180,
    hide:true,
    sortable: true,
  },
  {
    field: 'sum_m2_adjusted_budget_unit',
    headerName: `Bud U(${Month2})`,
    width: 170,
    sortable: true,
  },
  {
    field: 'sum_m2_adjusted_budget_value',
    headerName: `Bud V(${Month2})`,
    width: 180,
    sortable: true,
  },
  {
    field: 'sum_m3_adjusted_budget_unit',
    headerName: `Bud U(${Month3})`,
    width: 180,
    sortable: true,
  },
  {
    field: 'sum_m3_adjusted_budget_value',
    headerName: `Bud V(${Month3})`,
    width: 180,
    sortable: true,
  },

  
];


  return (
    <div style={{ height: 480, width: '100%' }}>
      <DataGrid
        rows={rows}
        Month1={Month1} 
        Month2={Month2} 
        Month3={Month3}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        density='compact'
      />
    </div>
  );
}
